import { Component } from "react";
import DownloadDocumentResultsGenAI from "./DownloadDocumntResultGnAI";
import GenAIPdfHeader from "./GenAIPdfHeader";
class PDFCitationdetailsGenAI extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedResults: [],
            collapsed: false,
            isFromPdf: false
        }
    }
    componentWillMount() {
        if(this.props.citationType && this.props.selectedResults){
        if (this.props.citationType === 'Marked Results') {
            this.setState({
                selectedResults: this.props.selectedResults,
                isFromPdf: true
            })
        }
        else {
            console.log('Read Displayed Results');
            this.setState({
                selectedResults: JSON.parse(localStorage.getItem('displayedResults'))
            })
        }
        if (this.props.titleOnly !== undefined && this.props.titleOnly === true) {
            this.setState({
                collapsed: true
            })
        }
        else {
            this.setState({
                collapsed: false
            })
        }
    }else{
        if (window.citationType === 'Marked Results') {
        this.setState({
                selectedResults: window.selectedResults,
                isFromPdf: false
            })
         }
         else {
             console.log('Read Displayed Results');
             this.setState({
                selectedResults: JSON.parse(localStorage.getItem('displayedResults'))
            })
         }
         if (window.titleOnly !== undefined && window.titleOnly === true) {
             this.setState({
                 collapsed: true
             })
         }
         else {
            this.setState({
                 collapsed: false
             })
         }
    }
    }
    resultList = (results) => {
        if (this.state.selectedResults.length > 0) {
            return (
                <>
                    {this.state.selectedResults.map((item, index) => {
                        return (
                            <>
                                <div key={`result-id-${index}`} id={`result-id-${index}`}>
                                    {
                                        <div className="gen-ai-resultDetailsDiv">
                                            <div className="doc-card">
                                                <DownloadDocumentResultsGenAI item={item.detail} count={item.index} itemTeaser={item.itemTeaser} customWidth={this.state.width} collapsed={this.state.collapsed}
                                                isFromPdf={this.state.isFromPdf} />
                                                <div className="resultsDivFooter">
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </>
                        )
                    })
                    }
                </>
            )
        }
    }
    render() {
        return (
            <div className="download-results-page-wrapper" style={{ float: 'right', borderBottom: 'none',width:`${this.props.customWidth}` }}>
                <GenAIPdfHeader />
                <div className="gen-ai-result-ContentWrapper">
                    <div className="gen-ai-results-wrapper">
                        {this.resultList(this.state.selectedResults)}
                    </div>
                </div>
            </div>
        )
        // return(

        //     <div className="download-results-page-contents-wrapper">
        //     {this.resultList(this.state.selectedResults)}
        //     </div>

        // )
    }
}
export default PDFCitationdetailsGenAI